module.exports = __webpack_public_path__ + "img/cf.beb97e94.svg";